import{TextStyle_TextAlignment as e}from"ricos-schema";const n={0:"indentZero",1:"indentOne",2:"indentTwo",3:"indentThree",4:"indentFour",5:"indentFive",6:"indentSix"},t={[e.LEFT]:"ltr",[e.RIGHT]:"rtl"};export{t as TO_DIR,n as indentLevelToClassName};
//# sourceMappingURL=consts.js.map
